import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';

import { Accordion, AccordionHeader, AccordionPanel, Typography2 } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import ReactPriceDisplay from 'bundles/ownable-products-common/components/ReactPriceDisplay';
import TeamsPurchaseCheckoutSummary from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummary';
import type { Props as PropsFromCaller } from 'bundles/teams-v2/components/TeamsPurchaseCheckoutSummary';

import _t from 'i18n!nls/teams-v2';

type PropsToComponent = PropsFromCaller;

const TeamsPurchaseCheckoutSummaryMobile = ({
  learnerCount,
  billingType,
  total,
  todaysTotal,
  organizationName,
  unitPrice,
  showEditLink,
  currency,
  loading,
  discountPercentage,
  discountAmount,
  discountedPrice,
  originalPrice,
}: PropsToComponent) => {
  const trackComponent = useRetracked();
  let todaysTotalEl = <span>&#8212;</span>;
  if (!loading && todaysTotal) {
    todaysTotalEl = <ReactPriceDisplay currency={currency} value={parseFloat(todaysTotal)} />;
  }
  const track = useTracker();

  const todaysTotalText = _t('Purchase Summary');

  const handleAccordionChange = (event: React.ChangeEvent<unknown>, expanded: boolean) => {
    trackComponent({ trackingData: {}, trackingName: 'mobile_checkout_summary_button', action: 'click' });
    track(expanded ? 'expand_accordion' : 'collapse_accordion', {
      accordion: {
        name: 'wes_funnel_checkout_summary',
      },
    });
  };

  return (
    <Accordion variant="standard" onChange={handleAccordionChange} css={{ width: '100%' }}>
      <AccordionHeader data-testid="teams-checkout-purchase-summary-accordion" label={todaysTotalText}>
        <Typography2 variant="subtitleMedium" component="div">
          {todaysTotalEl}
        </Typography2>
      </AccordionHeader>
      <AccordionPanel>
        <TeamsPurchaseCheckoutSummary
          total={total}
          todaysTotal={todaysTotal}
          organizationName={organizationName}
          learnerCount={learnerCount}
          billingType={billingType}
          unitPrice={unitPrice}
          showEditLink={showEditLink}
          loading={loading}
          currency={currency}
          discountPercentage={discountPercentage}
          discountAmount={discountAmount}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      </AccordionPanel>
    </Accordion>
  );
};

export default TeamsPurchaseCheckoutSummaryMobile;
